"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContainer = exports.toast = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var fa_1 = require("react-icons/fa");
var styles_1 = require("./styles");
var toasts = [];
var listeners = [];
var idCounter = 0;
function notifyListeners() {
    listeners.forEach(function (listener) { return listener(toasts); });
}
function pushToast(type, message) {
    var id = ++idCounter;
    toasts = __spreadArray(__spreadArray([], toasts, true), [{ id: id, type: type, message: message }], false);
    notifyListeners();
    setTimeout(function () {
        toasts = toasts.filter(function (item) { return item.id !== id; });
        notifyListeners();
    }, 5000);
}
exports.toast = {
    success: function (message) { return pushToast('success', message); },
    error: function (message) { return pushToast('error', message); },
};
function ToastContainer() {
    var _a = (0, react_1.useState)(toasts), items = _a[0], setItems = _a[1];
    (0, react_1.useEffect)(function () {
        listeners.push(setItems);
        return function () {
            listeners = listeners.filter(function (listener) { return listener !== setItems; });
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, { children: items.map(function (item) { return ((0, jsx_runtime_1.jsxs)(styles_1.ToastCard, __assign({ type: item.type }, { children: [item.type === 'success' ? (0, jsx_runtime_1.jsx)(fa_1.FaCheckCircle, {}) : (0, jsx_runtime_1.jsx)(fa_1.FaExclamationCircle, {}), (0, jsx_runtime_1.jsx)("span", { children: item.message })] }), item.id)); }) }));
}
exports.ToastContainer = ToastContainer;
